const ProductImagesData = [
    {
        id: 1,
        title: "Cable Tray Systems",
        image: `${process.env.PUBLIC_URL}/images/products/product-1.webp`,
        alt: "Cable Tray Systems"
    },
    {
        id: 2,
        title: "Ladder Type Cable Trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-2.webp`,
        alt: "Ladder Type Cable Trays"
    },
    {
        id: 3,
        title: "Ladder Type Cable Trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-3.webp`,
        alt: "Ladder Type Cable Trays"
    },
    {
        id: 4,
        title: "Ladder Type Cable Trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-4.webp`,
        alt: "Ladder Type Cable Trays"
    },
    {
        id: 5,
        title: "Ladder Type Cable Trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-5.webp`,
        alt: "Ladder Type Cable Trays"
    },
    {
        id: 6,
        title: "Perforated cable tray",
        image: `${process.env.PUBLIC_URL}/images/products/product-6.webp`,
        alt: "Perforated cable tray"
    },
    {
        id: 7,
        title: "Perforated cable tray",
        image: `${process.env.PUBLIC_URL}/images/products/product-7.webp`,
        alt: "Perforated cable tray"
    },
    {
        id: 8,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-8.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 9,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-9.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 10,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-10.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 11,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-11.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 12,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-12.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 13,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-13.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 14,
        title: "Clamps and Accessories ",
        image: `${process.env.PUBLIC_URL}/images/products/product-14.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 15,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-15.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 16,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-16.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 17,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-17.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 18,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-18.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 19,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-19.webp`,
        alt: "Clamps and Accessories "
    },
    {
        id: 20,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-20.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 21,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-21.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 22,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-22.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 23,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-23.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 24,
        title: "Clamps and Accessories",
        image: `${process.env.PUBLIC_URL}/images/products/product-24.webp`,
        alt: "Clamps and Accessories"
    },
    {
        id: 25,
        title: "Threaded Rods",
        image: `${process.env.PUBLIC_URL}/images/products/product-25.webp`,
        alt: "Threaded Rods"
    },
    {
        id: 26,
        title: "GI Earthing Strip",
        image: `${process.env.PUBLIC_URL}/images/products/product-26.webp`,
        alt: "GI Earthing Strip"
    },
    {
        id: 27,
        title: "Solar Mounting Clamps",
        image: `${process.env.PUBLIC_URL}/images/products/product-27.webp`,
        alt: "Solar Mounting Clamps"
    },
    {
        id: 28,
        title: "Raceway type cable trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-29.webp`,
        alt: "Raceway type cable trays"
    },
    {
        id: 29,
        title: "FRP cable trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-30.webp`,
        alt: "FRP cable trays"
    },
     {
        id: 30,
        title: "FRP cable trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-31.webp`,
        alt: "FRP cable trays"
    }
];

export default ProductImagesData;
